import React, { useEffect, useState } from 'react';

import ReactTable from '../components/ReactTable';
import { useCompetenciesCols } from '../hooks/EmployeeCols';
import fetchFromAthena from '../functions/FetchFromAthena'

export default function Competencies(props) {
    const CompetenciesCols = useCompetenciesCols();
    const [state,setState] = useState({
        data: [],
        isLoading: true
    })

    useEffect(() => {
        getCompetencies()
    },[])

    const getCompetencies = async() => {
        const queries = ['employee_competencies_read']

      const data = await Promise.allSettled(
        queries.map(query =>
          fetchFromAthena({
            queryName: query,
            headers: {
              company: props.company,
              empId: props.empId
            },
            accessToken: props.credentials.user.accessToken,
            credentials: props.credentials
          })
        )
      ).then(results => {
        return results
      })
      
      setState({
        isLoading: false,
        data: data[0].value
      })
    }
      return <ReactTable isLoading={state.isLoading} cols={CompetenciesCols} data={state.data} />;
}
